// this file is automatically generated by version.generator.ts script
export const versions = {
  version: '4.88.0-beta.67d4a7b9',
  revision: '67d4a7b9',
  branch: 'develop',
  date: 'Mon, 30 Mar 2026 17:22:00 GMT'
};